/**
 * Web Skeleton Figures
 *
 */

import Article from './Article'
import Table from './Table'
import Circle from './Circle'
import Product from './Product'

export { Article, Table, Circle, Product }
